import { Component } from '@angular/core';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerPlateModel } from '../../titleregistration/models/customer-plate.model';
import { PlateService } from '../../titleregistration/services/plate.service';
import { PlateType } from '../../titleregistration/models/enums/plate-type.enum';
import { PlateStatusType } from '../../titleregistration/models/enums/plate-status-type.enum';

@Component({
    selector: 'historical-customer-placard',
    templateUrl: './historical-customer-placard.html',
    inputs: ['customerNumber', 'placards']
})

export class HistoricalCustomerPlacardComponent extends BaseComponent {
    public placards: CustomerPlateModel[];
    public placardDisplayInfo: any[];
    public customerNumber: number;
    public placardTypes: PlateType = new PlateType();
    public statusTypes: PlateStatusType = new PlateStatusType();

    constructor(private placardService: PlateService) {
        super();
    }

    ngOnInit() {
        if (this.placards !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateCharacteristics(this.customerNumber);
        }
    }

    populateCharacteristics(customerNumberId: number) {
        this.displayResults = false;
        this.placardService.getAllPlacardsByCustomerNumber(customerNumberId)
            .subscribe(
                result => {
                    this.placards = result.filter(p => !p.active);
                },
                e => console.log('error', e),
                () => {
                    this.denormalizeData();
                    this.displayResults = true;
                });
    }

    denormalizeData() {
        this.placardDisplayInfo = [];
        for (let placard of this.placards) {
            this.placardDisplayInfo.push({
                placardNumber: placard.plate.plateNumber,
                placardType: this.getPlateType(placard.plate.plateConfiguration.plateTypeId),
                placardIssueDate: placard.issueDate,
                placardExpirationDate: placard.expiredDate,
                placardStatus: this.getStatus(placard.plate.plateStatusTypeId)
            });
        }
    }

    getStatus(statusId: number): string {
        let displayValue = this.statusTypes.FromId(statusId).displayValue;
        if (null == displayValue) {
            throw `Template type ${statusId} is missing.`;
        }
        return displayValue;
    }

    getPlateType(plateTypeId: number) {
        let displayValue = this.placardTypes.FromId(plateTypeId).displayValue;
        if (null == displayValue) {
            throw `Template type ${plateTypeId} is missing.`;
        }
        return displayValue;
    }
}
